export const customerTypes = [{
  label: 'Pessoa física',
  value: 'true',
}, {
  label: 'Pessoa jurídica',
  value: 'false',
}];

export const situationTypes = [{
  label: 'Ativo',
  value: 'true',
}, {
  label: 'Inativo',
  value: 'false',
}];

export default [{
  label: 'Sim',
  value: 'true',
}, {
  label: 'Não',
  value: 'false',
}];
